import './src/styles/app.scss';

// Required for Redux to work in Gatsby
import wrapWithProvider from "./wrap-with-provider"

import { initializeIcons } from '@uifabric/icons';
initializeIcons();

export const wrapRootElement = wrapWithProvider